import { Component, Input } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { LoaderComponent } from '../../loader/loader.component';
import { NgTemplateOutlet } from '@angular/common';
import { MatMenuItem } from '@angular/material/menu';

@Component({
  imports: [MatButtonModule, MatIconModule, MatTooltipModule, TranslatePipe, LoaderComponent, NgTemplateOutlet, MatMenuItem],
  selector: 'app-task-button',
  templateUrl: './task-button.component.html',
  styleUrls: ['./task-button.component.scss'],
  standalone: true,
})
export class TaskButtonComponent {
  @Input()
  loading = false;

  @Input()
  loadingLabel = '';

  @Input()
  taskLabel = '';

  @Input()
  icon = '';

  @Input()
  color: ThemePalette = undefined;

  @Input()
  clickAction: Function;

  @Input()
  disabled = false;

  @Input()
  buttonType: undefined | 'raised' | 'icon' | 'stroked';

  @Input()
  isMatMenuItem = false;

  @Input()
  alignWithOptionsMenu = false;

  @Input()
  tooltip: string;

  @Input()
  role = 'task-button';

  @Input()
  useContent = false;
}
